/**
 * CallCancelModal - Модальное окно для отмены звонка
 */
import React, { useState } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { IconAlertCircle, IconBan } from '@tabler/icons-react';

const CallCancelModal = ({
  opened,
  onClose,
  onSubmit,
  call,
  loading = false,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);

  // Сброс формы при открытии
  React.useEffect(() => {
    if (opened) {
      setReason('');
      setError(null);
    }
  }, [opened]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await onSubmit({
        reason: reason.trim() || null,
      });
    } catch (err) {
      setError(err.message || 'Ошибка при отмене звонка');
    }
  };

  const contactName = call?.contact
    ? [call.contact.last_name, call.contact.first_name].filter(Boolean).join(' ')
    : 'Неизвестный контакт';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Отменить звонок"
      size="md"
      radius="xl"
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
              {error}
            </Alert>
          )}

          <Alert color="orange" variant="light">
            <Text size="sm">
              Вы уверены, что хотите отменить запланированный звонок с <strong>{contactName}</strong>?
            </Text>
          </Alert>

          <Textarea
            label="Причина отмены (опционально)"
            placeholder="Клиент отказался, неактуально..."
            autosize
            minRows={2}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={onClose}>
              Не отменять
            </Button>
            <Button
              type="submit"
              loading={loading}
              color="red"
              leftSection={<IconBan size={16} />}
            >
              Отменить звонок
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default CallCancelModal;
